import React from 'react';
import { Link } from 'react-router-dom';
import { services, servicesIntro } from '../../content/site';
import { ArrowRight } from '../Common/Icons';

const OurServices = () => (
  <section className="section section--paper2" id="services">
    <div className="container">
      <div className="section-head section-head--center">
        <p className="eyebrow">Our Services</p>
        <h2>What we build, and how we deliver it.</h2>
        <p className="section-head__lead">{servicesIntro}</p>
      </div>

      <div className="services__grid">
        {services.map((service, i) => (
          <Link
            to={service.link}
            key={service.id}
            className="service-card reveal"
            style={{ '--reveal-delay': `${i * 90}ms` }}
          >
            <div className="service-card__media">
              <span className="service-card__index">{String(i + 1).padStart(2, '0')}</span>
              <img
                src={service.image}
                alt={`LIDA Engineering ${service.title.toLowerCase()} work`}
                loading="lazy"
                decoding="async"
              />
            </div>

            <div className="service-card__body">
              <h3 className="service-card__title">{service.title}</h3>
              <p className="service-card__summary">{service.summary}</p>
              <span className="link-arrow service-card__cta">
                Read more
                <ArrowRight size={15} />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  </section>
);

export default OurServices;
